<div class="modal-header">
  <h5 class="modal-title" *ngIf="isAdd">Добавление объекта недвижимости</h5>
  <h5 class="modal-title" *ngIf="!isAdd">Редактирование объекта недвижимости</h5>
  <button type="button" class="close" mat-dialog-close style="outline: none">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body property-window">

  <div class="form form-horizontal">

    <div class="form-body">

      <!-- Name -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Вид, наименование <span class="danger">*</span></label>
        <div class="col-md-6">
          <mat-form-field>
              <mat-select required [(ngModel)]="object.name">
                <mat-option *ngFor="let option of nameObjects" [value]="option.name">
                  {{option.name}}
                </mat-option>
              </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Kind -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Вид собственности <span class="danger">*</span></label>
        <div class="col-md-6">
          <mat-form-field>
            <mat-select required [(ngModel)]="object.type">
              <mat-option *ngFor="let option of typeObjects" [value]="option.name">
                {{option.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Address -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Адрес <span class="danger">*</span></label>
        <div class="col-md-6">
          <mat-form-field>
            <mat-select required [(ngModel)]="object.address">
              <mat-option *ngFor="let option of addressObjects" [value]="option.name">
                {{option.name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <!-- S -->
      <div class="form-group row">
        <label class="col-md-3 label-control">Площадь <span class="danger">*</span></label>
        <div class="col-md-6">
          <input class="form-control" [(ngModel)]="object.landS"
                 type="text" placeholder="площадь недвижимости в кв. м."
                 pattern="[0-9\.]+"
                 required #itemS="ngModel">
          <ng-container *ngIf="itemS.invalid && (itemS.dirty || itemS.touched)">
            <small class="form-text text-muted danger"
                   *ngIf="itemS.errors.required">это поле обязательно для заполнения</small>
            <small class="form-text text-muted danger"
                   *ngIf="itemS.errors.pattern">вводить можно только цифры</small>
          </ng-container>
        </div>
      </div>

    </div>

  </div>

</div>

<div class="modal-footer" style="justify-content: center">
  <button class="btn btn-raised btn-warning" mat-dialog-close>Отмена</button>
  <button class="btn btn-raised btn-info" (click)=save()>Сохранить</button>
</div>

